/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export const pointHandPose = {
    jointTransforms: {
        wrist: {
            offsetMatrix: [
                0.9340395331382751, -0.13936476409435272, 0.32885703444480896, 0,
                -0.005510995630174875, 0.914999783039093, 0.40341612696647644, 0,
                -0.3571262061595917, -0.37861889600753784, 0.8538784384727478, 0,
                -0.05789132043719292, 0.01670890860259533, 0.11183350533246994, 1,
            ],
            radius: 0.021460847929120064,
        },
        'thumb-metacarpal': {
            offsetMatrix: [
                0.02145560085773468, -0.9978390336036682, 0.0621047280728817, 0,
                0.41311800479888916, 0.06541631370782852, 0.9083252549171448, 0,
                -0.9104245901107788, 0.006167683284729719, 0.4136286973953247, 0,
                -0.016488194465637207, 0.012708572670817375, 0.08862338215112686, 1,
            ],
            radius: 0.019382517784833908,
        },
        'thumb-phalanx-proximal': {
            offsetMatrix: [
                0.21270370483398438, -0.966137707233429, 0.14606566727161407, 0,
                0.49890995025634766, 0.2359165996313095, 0.8339261412620544, 0,
                -0.8401462435722351, -0.10450579971075058, 0.5321959853172302, 0,
                0.013112368993461132, 0.012508046813309193, 0.07517509907484055, 1,
            ],
            radius: 0.01228295173496008,
        },
        'thumb-phalanx-distal': {
            offsetMatrix: [
                0.01653280481696129, -0.9986647963523865, 0.048943229019641876, 0,
                0.26313456892967224, 0.051570065319538116, 0.9633802771568298, 0,
                -0.9646173715591431, -0.0030490627977997065, 0.26363563537597656, 0,
                0.04150351136922836, 0.016039609909057617, 0.05719054117798805, 1,
            ],
            radius: 0.009768804535269737,
        },
        'thumb-tip': {
            offsetMatrix: [
                0.01653280481696129, -0.9986647963523865, 0.048943229019641876, 0,
                0.26313456892967224, 0.051570065319538116, 0.9633802771568298, 0,
                -0.9646173715591431, -0.0030490627977997065, 0.26363563537597656, 0,
                0.06548332422971725, 0.01683700829744339, 0.0516640841960907, 1,
            ],
            radius: 0.008768804371356964,
        },
        'index-finger-metacarpal': {
            offsetMatrix: [
                0.9340395331382751, -0.13936476409435272, 0.32885703444480896, 0,
                -0.005510995630174875, 0.914999783039093, 0.40341612696647644, 0,
                -0.3571262061595917, -0.37861889600753784, 0.8538784384727478, 0,
                -0.02592567168176174, 0.019982583820819855, 0.08479326963424683, 1,
            ],
            radius: 0.021228281781077385,
        },
        'index-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9063700437545776, -0.21756279468536377, 0.3621589243412018, 0,
                0.0970839336514473, 0.9415287375450134, 0.3226419687271118, 0,
                -0.41117796301841736, -0.2572731077671051, 0.8744958639144897, 0,
                -0.0015709538711234927, 0.043078210204839706, 0.034657616168260574, 1,
            ],
            radius: 0.010295259766280651,
        },
        'index-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.9159826040267944, -0.1651475727558136, 0.36565208435058594, 0,
                0.09755707532167435, 0.9756820797920227, 0.1962820291519165, 0,
                -0.3891757130622864, -0.14411886036396027, 0.9098196625709534, 0,
                0.014023927971720695, 0.052835866808891296, 0.0014903299743309617, 1,
            ],
            radius: 0.00853810179978609,
        },
        'index-finger-phalanx-distal': {
            offsetMatrix: [
                0.9378057718276978, -0.12329639494419098, 0.3245268166065216, 0,
                0.032558172941207886, 0.9619227051734924, 0.2713746726512909, 0,
                -0.3456292748451233, -0.2439306229352951, 0.9061115384101868, 0,
                0.023482320830225945, 0.05633850023150444, -0.020621655508875847, 1,
            ],
            radius: 0.007636196445673704,
        },
        'index-finger-tip': {
            offsetMatrix: [
                0.9378057718276978, -0.12329639494419098, 0.3245268166065216, 0,
                0.032558172941207886, 0.9619227051734924, 0.2713746726512909, 0,
                -0.3456292748451233, -0.2439306229352951, 0.9061115384101868, 0,
                0.03096788562834263, 0.06281610578298569, -0.040703095495700836, 1,
            ],
            radius: 0.006636196281760931,
        },
        'middle-finger-metacarpal': {
            offsetMatrix: [
                0.9340395331382751, -0.13936476409435272, 0.32885703444480896, 0,
                -0.005510995630174875, 0.914999783039093, 0.40341612696647644, 0,
                -0.3571262061595917, -0.37861889600753784, 0.8538784384727478, 0,
                -0.04184452444314957, 0.022474845871329308, 0.08177298307418823, 1,
            ],
            radius: 0.021231964230537415,
        },
        'middle-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9720265865325928, -0.08313076198101044, 0.21966552734375, 0,
                0.20477405190467834, 0.7580050826072693, -0.6192700862884521, 0,
                -0.11502730846405029, 0.6469289064407349, 0.7538246512413025, 0,
                -0.022107340395450592, 0.05035499855875969, 0.02970452979207039, 1,
            ],
            radius: 0.01117393933236599,
        },
        'middle-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.9779140949249268, -0.07129573822021484, 0.19646917283535004, 0,
                0.1287083923816681, -0.5352076292037964, -0.8348574042320251, 0,
                0.1646735966205597, 0.8417060971260071, -0.5142109394073486, 0,
                -0.017169542610645294, 0.022584279999136925, -0.00265491777099669, 1,
            ],
            radius: 0.008030958473682404,
        },
        'middle-finger-phalanx-distal': {
            offsetMatrix: [
                0.9774913787841797, -0.19657190144062042, 0.07661263644695282, 0,
                -0.1924918293952942, -0.9796126484870911, -0.05749811604619026, 0,
                0.08635343611240387, 0.041456472128629684, -0.995401918888092, 0,
                -0.02170622907578945, -0.0006043742760084569, 0.011511396616697311, 1,
            ],
            radius: 0.007629410829395056,
        },
        'middle-finger-tip': {
            offsetMatrix: [
                0.9774913787841797, -0.19657190144062042, 0.07661263644695282, 0,
                -0.1924918293952942, -0.9796126484870911, -0.05749811604619026, 0,
                0.08635343611240387, 0.041456472128629684, -0.995401918888092, 0,
                -0.02438267692923546, -0.0026927536819130182, 0.03627248480916023, 1,
            ],
            radius: 0.006629410665482283,
        },
        'ring-finger-metacarpal': {
            offsetMatrix: [
                0.9340395331382751, -0.13936476409435272, 0.32885703444480896, 0,
                -0.005510995630174875, 0.914999783039093, 0.40341612696647644, 0,
                -0.3571262061595917, -0.37861889600753784, 0.8538784384727478, 0,
                -0.05944233387708664, 0.0264605600386858, 0.07478221505880356, 1,
            ],
            radius: 0.019088275730609894,
        },
        'ring-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9842101335525513, 0.024470895528793335, 0.1753024309873581, 0,
                0.12200043350458145, 0.6237703561782837, -0.7720272541046143, 0,
                -0.12824076414108276, 0.7812241315841675, 0.610936164855957, 0,
                -0.04249368980526924, 0.0467497780919075, 0.027722163125872612, 1,
            ],
            radius: 0.00992213748395443,
        },
        'ring-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.9941774606704712, 0.05949164181947708, 0.08983955532312393, 0,
                0.10504482686519623, -0.7208291888237, -0.6851072907447815, 0,
                0.024001073092222214, 0.6905553936958313, -0.7228817939758301, 0,
                -0.0374927744269371, 0.016285063698887825, 0.0038980208337306976, 1,
            ],
            radius: 0.007611672393977642,
        },
        'ring-finger-phalanx-distal': {
            offsetMatrix: [
                0.9995742440223694, 0.01638498157262802, 0.02412819117307663, 0,
                0.007813597097992897, -0.9474818110466003, 0.31971633434295654, 0,
                0.028100071474909782, -0.31939181685447693, -0.9472070932388306, 0,
                -0.038130562752485275, -0.0020653479732573032, 0.02310742810368538, 1,
            ],
            radius: 0.007231088820844889,
        },
        'ring-finger-tip': {
            offsetMatrix: [
                0.9995742440223694, 0.01638498157262802, 0.02412819117307663, 0,
                0.007813597097992897, -0.9474818110466003, 0.31971633434295654, 0,
                0.028100071474909782, -0.31939181685447693, -0.9472070932388306, 0,
                -0.0390593595802784, 0.004176302347332239, 0.0466572530567646, 1,
            ],
            radius: 0.0062310886569321156,
        },
        'pinky-finger-metacarpal': {
            offsetMatrix: [
                0.9147363901138306, 0.3458845317363739, 0.20885537564754486, 0,
                -0.3923271894454956, 0.8839452862739563, 0.2544005811214447, 0,
                -0.09662359952926636, -0.3146490156650543, 0.9442773461341858, 0,
                -0.06715242564678192, 0.024195827543735504, 0.07137546688318253, 1,
            ],
            radius: 0.01808827556669712,
        },
        'pinky-finger-phalanx-proximal': {
            offsetMatrix: [
                0.9613109827041626, 0.22439135611057281, 0.15977802872657776, 0,
                0.01002211682498455, 0.5511574745178223, -0.8343409299850464, 0,
                -0.27528178691864014, 0.8036624789237976, 0.5275853276252747, 0,
                -0.06273911893367767, 0.038559623062610626, 0.028268879279494286, 1,
            ],
            radius: 0.008483353070914745,
        },
        'pinky-finger-phalanx-intermediate': {
            offsetMatrix: [
                0.9820972084999084, 0.18811029195785522, -0.00995189044624567, 0,
                0.14063723385334015, -0.7673450708389282, -0.6256227493286133, 0,
                -0.12532226741313934, 0.6130226850509644, -0.7800630927085876, 0,
                -0.05428232625126839, 0.013870777562260628, 0.012061242014169693, 1,
            ],
            radius: 0.0067641944624483585,
        },
        'pinky-finger-phalanx-distal': {
            offsetMatrix: [
                0.9744614362716675, 0.20454788208007812, -0.09265263378620148, 0,
                0.22429193556308746, -0.9065253138542175, 0.35764020681381226, 0,
                -0.010836843401193619, -0.3692878782749176, -0.9292529225349426, 0,
                -0.05173685774207115, 0.0014194445684552193, 0.02790539152920246, 1,
            ],
            radius: 0.0064259846694767475,
        },
        'pinky-finger-tip': {
            offsetMatrix: [
                0.9744614362716675, 0.20454788208007812, -0.09265263378620148, 0,
                0.22429193556308746, -0.9065253138542175, 0.35764020681381226, 0,
                -0.010836843401193619, -0.3692878782749176, -0.9292529225349426, 0,
                -0.05098633095622063, 0.008463085629045963, 0.048688892275094986, 1,
            ],
            radius: 0.005425984505563974,
        },
    },
    gripOffsetMatrix: [
        0.005510995630174875, -0.9149997234344482, -0.40341615676879883, 0,
        -0.3571262061595917, -0.37861889600753784, 0.8538784384727478, 0,
        -0.9340395331382751, 0.13936474919319153, -0.32885703444480896, 0,
        -0.031803809106349945, 0.007837686687707901, 0.04313928261399269, 1,
    ],
};
//# sourceMappingURL=point.js.map